export enum AmostrasCatalisadoresScopesEnum {
  ComAmostrasAmostrasLogUsuarios = 'ComAmostrasAmostrasLogUsuarios',
}

export enum AmostrasCatalisadoresEventsEnum {
  Removida = 'amostra-catalisador-removida',
  Recebidas = 'amostras-catalisadores-recebidas-producao',
  Coletadas = 'amostras-catalisadores-coletadas-laboratorio',
}
